export const TITLE = "Grundrissformatierung";
export const SUB1_TITLE1 = "Bezeichnung";
export const SUB1_TITLE1_WIDTH = "Exportbreite";
export const SUB1_TITLE1_HEIGHT = "Exporthöhe";
export const UNIT = "cm";
